<template>
    <div class="d-flex flex-column flex-root">
        <!-- <HeaderMobile  /> -->

        <Loader />

        <div class="d-flex flex-row flex-column-fluid page justify-content-center">
            <base-alert/>
            <div class="d-flex flex-column flex-row-fluid wrapper">
                <Header  />
                     
                <div class="content d-flex flex-column flex-column-fluid">
                    <div class="container">
                                   
                        <router-view />
                    </div>
                </div>

                <Footer />
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

import {ADD_BODY_CLASSNAME} from "@/store/htmlclass.module";

import Loader from "@/views/layout/content/loader";

import Header from "./header/header";
import HeaderMobile from "./header/header_mobile";
import Footer from "./footer/footer";
import BaseAlert from "@/components/UI/BaseAlert.vue";
let regexp = /android|iphone|kindle|ipad/i; 
const isMobileDevice = regexp.test(navigator.userAgent);   

export default {
    name: "Layout",
    components: {
        Header,
        HeaderMobile,
        Loader,
        Footer,
        BaseAlert
    },
    computed: {
        ...mapGetters([
            "authenticated"
        ]),
    },
    beforeMount() {
        this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
    },
    mounted() {
        if (!this.authenticated)
            this.$router.push({name: "login"});
    }
};
</script>
